/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import PropTypes from 'prop-types';

/**
 * UnavailableBundleMessage component is used to display a styled message indicating that a bundle is unavailable.
 * It includes a title and an optional section for additional content, such as buttons or explanatory text.
 */
const UnavailableBundleMessage = ({ unavailableBundleMessageText, children = null }) => (
  <div data-testid="unavailable-bundle" className="sui-flex sui-flex-col sui-gap-5 sui-items-end">
    <h2 className="sui-h2-bold sui-line-clamp-unset sui-text-primary sui-text-3xl">{unavailableBundleMessageText}</h2>
    <div className="sui-max-w-[220px] [&_button]:sui-text-right [&_a]:sui-text-right">
      {children}
    </div>
  </div>
);

UnavailableBundleMessage.propTypes = {
  children: PropTypes.node,
  unavailableBundleMessageText: PropTypes.string.isRequired
};


export default UnavailableBundleMessage;